import { createAsyncThunk, AnyAction } from "@reduxjs/toolkit"
import { ThunkDispatch } from "redux-thunk"

import i18n from "config/i18n"
import { API } from "redux/api"

export const fetchDebtContractAttachment = createAsyncThunk(
  "debt-contract-attachment/fetch",
  async (values: { debt_id: string }) => {
    const response = await API.get(`/debts/${values.debt_id}/download`)
    return response.data
  },
)

export const makeDownloadDebtContract = ({ debt_id }: { debt_id: string }) => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise<{ url: string }>((resolve, reject) => {
      return dispatch(fetchDebtContractAttachment({ debt_id }))
        .then(
          ({ payload }) => {
            if (!payload) {
              return reject(i18n.t("notice.debt.download.unavailable"))
            }

            if (payload?.attachment) {
              const { attachment } = payload

              if (attachment?.file?.url) {
                resolve({ url: attachment.file.url })
              }
            }
          },
          () => {
            reject(i18n.t("notice.debt.download.failure"))
          },
        )
        .catch((error) => {
          reject(error)
        })
    })
  }
}
